"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _block = require("./block");
var LineGraph = function(param) {
    var level = param.level, lowText = param.lowText, highText = param.highText, length = param.length;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
        style: {
            width: "100%",
            color: "#333",
            padding: "10px",
            display: "block",
            position: "relative"
        },
        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)("div", {
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Flex, {
                    justify: "flex-start",
                    align: "flex-start",
                    direction: "row",
                    wrap: "wrap",
                    id: "graph",
                    style: {
                        width: "100%",
                        borderBottom: "1px solid #b4b4b4",
                        paddingBottom: "0.5rem",
                        marginBottom: "0.6rem"
                    },
                    children: Array(Number.parseInt(length)).fill(true).map(function(_, i) {
                        return /*#__PURE__*/ (0, _jsxruntime.jsx)(_block.Block, {
                            lines: i + 1,
                            busy: i < level,
                            width: 100 / Number.parseInt(length)
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                    style: {
                        fontSize: "0.875rem",
                        width: "100%"
                    },
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                            children: lowText
                        }),
                        /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                            children: highText
                        })
                    ]
                })
            ]
        })
    });
};
var _default = LineGraph;
